'use client'

import React, { useState } from 'react'
import Image from 'next/image'
import styles from './storiesSection.module.scss'
import { type StoryItem } from '../interface/StoriesList'
import type StoriesList from '../interface/StoriesList'
import AuthorStoryItem from './authorStoryItem'

interface StoriesSectionProps {
  authorName: string
  storiesList: StoriesList
  isReviewer?: boolean
}

const entriesPerPage = 8
const readMoreStoriesLogo = 'https://acko-cms.ackoassets.com/read_more_arrow_a0010e4557.svg'

const getInitialVisibleItems = (items: StoryItem[]) => items.slice(0, entriesPerPage)

const StoriesSection: React.FC<StoriesSectionProps> = ({ authorName, storiesList, isReviewer = false }) => {
  const [selectedTab, setSelectedTab] = useState(Object.keys(storiesList)[0])
  const [visibleItems, setVisibleItems] = useState(getInitialVisibleItems(storiesList[selectedTab]))

  const handleReadMoreButton = () => {
    const nextItems = storiesList[selectedTab].slice(visibleItems.length, visibleItems.length + entriesPerPage)
    setVisibleItems(prevItems => [...prevItems, ...nextItems])
  }

  const handleTabClick = (key: string) => {
    setSelectedTab(key)
    setVisibleItems(getInitialVisibleItems(storiesList[key]))
  }

  return (
    <div className={styles.storiesSectionRootContainer}>
      <div className={styles.storiesSectionHeader}>
        <div className={styles.storiesHeading}>{`${isReviewer ? 'Reviewed by' : 'Stories by'} ${authorName}`}</div>
        <div className={styles.storiesTabs}>
          {Object.keys(storiesList).map(key => (
            <button
              type="button"
              key={key}
              className={`${styles.tabButton} ${selectedTab === key ? styles.tabActive : ''}`}
              onClick={() => handleTabClick(key)}>
              {key}
            </button>
          ))}
        </div>
      </div>
      <div className={styles.tabContent}>
        {visibleItems.map(item => (
          <AuthorStoryItem item={item} />
        ))}
      </div>
      {visibleItems.length < storiesList[selectedTab].length && (
        <button className={styles.readMoreStoriesButton} onClick={handleReadMoreButton} type="button">
          Read more stories
          <Image src={readMoreStoriesLogo} width={24} height={24} alt="Read mode stories logo" loading="lazy" />
        </button>
      )}
    </div>
  )
}

export default StoriesSection
